import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
/**
 * \@title Stepper overview
 */
export class StepperOverviewExample {
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
/**
 * @param {?} _formBuilder
 */
constructor(private _formBuilder: FormBuilder) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'stepper-overview-example',
  templateUrl: 'stepper-overview-example.html',
  styleUrls: ['stepper-overview-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
];
}

function StepperOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
StepperOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StepperOverviewExample.ctorParameters;
/** @type {?} */
StepperOverviewExample.prototype.isLinear;
/** @type {?} */
StepperOverviewExample.prototype.firstFormGroup;
/** @type {?} */
StepperOverviewExample.prototype.secondFormGroup;
/** @type {?} */
StepperOverviewExample.prototype._formBuilder;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
